/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import {
	useRequestData,
	useLabels,
	useSitemap,
	usePrefs
} from 'wsm-common-data';
import { setClassNames } from '@ddc/classnames-js';
import { trackEvent } from 'ddc-track-event';
import PropTypes from 'prop-types';
import { buildContactUsUrl } from '../util/index';

function CTASection({ offerData }) {
	const {
		customer,
		offer: { offerId },
		vdpLink,
		uuid
	} = offerData;
	const { deviceType, windowId, widgetName } = useRequestData();
	const { vdpButtonLabel, contactButtonLabel } = usePrefs();
	const labels = useLabels();
	const sitemap = useSitemap();
	const leadForm = sitemap.get('INVENTORY_LEAD_AMP');
	const isDesktop = deviceType === 'DESKTOP';
	const ctaContainerClasses = [
		'cta-container',
		'mb-8',
		isDesktop ? 'd-flex justify-content-start mb-5 mt-5' : 'pb-5'
	];
	const firstButtonClasses = [
		'btn',
		'btn-default',
		isDesktop ? 'd-inline-block mr-4' : 'd-block my-3'
	];

	const secondButtonClasses = [
		'dialog',
		'btn',
		'btn-primary',
		isDesktop ? 'd-inline-block' : 'd-block my-3 btn-block'
	];

	const handleClick = () => {
		trackEvent(widgetName, windowId, {
			element: 'CTA Button/Link',
			elementCTA: labels.get(vdpButtonLabel),
			result: 'Navigated to VDP'
		});
	};

	return (
		<div className={setClassNames(ctaContainerClasses)}>
			<a
				onClick={handleClick}
				href={vdpLink}
				className={setClassNames(firstButtonClasses)}
			>
				{labels.get(vdpButtonLabel)}
			</a>
			<a
				href="#"
				type="button"
				data-href={buildContactUsUrl(leadForm, customer, {
					offerId,
					itemId: uuid
				})}
				className={setClassNames(secondButtonClasses)}
			>
				{labels.get(contactButtonLabel)}
			</a>
		</div>
	);
}

CTASection.propTypes = {
	offerData: PropTypes.shape({
		uuid: PropTypes.string,
		vdpLink: PropTypes.string,
		customer: PropTypes.shape(),
		offer: PropTypes.shape({
			offerId: PropTypes.string
		})
	})
};

export default CTASection;
